/* DeMellier-style theme interactions — vanilla, no dependencies */
(function () {
  "use strict";

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* ---------- Mobile menu ---------- */
  function openMenu() {
    const m = $("[data-menu]"), o = $("[data-menu-overlay]");
    if (m) m.classList.add("is-open");
    if (o) o.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }
  function closeMenu() {
    const m = $("[data-menu]"), o = $("[data-menu-overlay]");
    if (m) m.classList.remove("is-open");
    if (o) o.classList.remove("is-open");
    document.body.style.overflow = "";
  }
  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-menu-open]")) { e.preventDefault(); openMenu(); }
    if (e.target.closest("[data-menu-close]")) { e.preventDefault(); closeMenu(); }
    if (e.target.matches("[data-menu-overlay]")) closeMenu();
    const subBtn = e.target.closest("[data-sub-toggle]");
    if (subBtn) {
      const group = subBtn.closest(".mobile-nav__group");
      const sub = $(".mobile-nav__sub", group);
      const open = group.classList.toggle("is-open");
      sub.style.maxHeight = open ? sub.scrollHeight + "px" : 0;
    }
  });

  /* ---------- Cart drawer (delegated; survives AJAX re-render) ---------- */
  function openDrawer() {
    const d = $("[data-drawer]"), o = $("[data-drawer-overlay]");
    if (!d) return;
    d.classList.add("is-open");
    if (o) o.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }
  function closeDrawer() {
    const d = $("[data-drawer]"), o = $("[data-drawer-overlay]");
    if (d) d.classList.remove("is-open");
    if (o) o.classList.remove("is-open");
    document.body.style.overflow = "";
  }
  window.__openCartDrawer = openDrawer;
  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-open-cart]")) { e.preventDefault(); openDrawer(); }
    if (e.target.closest("[data-close-cart]")) { e.preventDefault(); closeDrawer(); }
    if (e.target.matches("[data-drawer-overlay]")) closeDrawer();
  });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeDrawer(); });

  /* ---------- Generic poppers (filter / sort) ---------- */
  $$("[data-popper-toggle]").forEach((btn) => {
    const pop = $("#" + btn.getAttribute("data-popper-toggle"));
    if (!pop) return;
    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      const willOpen = !pop.classList.contains("is-open");
      $$(".popper.is-open").forEach((p) => p.classList.remove("is-open"));
      pop.classList.toggle("is-open", willOpen);
    });
    pop.addEventListener("click", (e) => e.stopPropagation());
  });
  document.addEventListener("click", () =>
    $$(".popper.is-open").forEach((p) => p.classList.remove("is-open"))
  );

  /* ---------- Collection view switch (2 / 4 / 6) ---------- */
  const grid = $("[data-grid]");
  $$("[data-view-btn]").forEach((btn) => {
    btn.addEventListener("click", () => {
      $$("[data-view-btn]").forEach((b) => b.classList.remove("is-active"));
      btn.classList.add("is-active");
      if (grid) grid.setAttribute("data-view", btn.getAttribute("data-view-btn"));
    });
  });

  /* ---------- Accordions ---------- */
  $$(".accordion__head").forEach((head) => {
    head.addEventListener("click", () => {
      const item = head.closest(".accordion__item");
      const panel = $(".accordion__panel", item);
      const open = item.classList.toggle("is-open");
      panel.style.maxHeight = open ? panel.scrollHeight + "px" : 0;
    });
  });

  /* ---------- Material tabs filter colour swatches by material ---------- */
  $$("[data-mat-tabs]").forEach((tabs) => {
    const swatches = $$("[data-swatches] .swatch");
    tabs.querySelectorAll("button").forEach((tab) => {
      tab.addEventListener("click", () => {
        tabs.querySelectorAll("button").forEach((t) => t.classList.remove("is-active"));
        tab.classList.add("is-active");
        const m = (tab.getAttribute("data-material") || "").toLowerCase().trim();
        if (!m) { swatches.forEach((sw) => (sw.style.display = "")); return; }
        // would this filter hide everything? if so, show all (data not tagged)
        const anyMatch = swatches.some((sw) =>
          (sw.dataset.materials || "").toLowerCase().split(/\s+/).includes(m)
        );
        swatches.forEach((sw) => {
          const mats = (sw.dataset.materials || "").toLowerCase().split(/\s+/);
          sw.style.display = (!anyMatch || mats.includes(m)) ? "" : "none";
        });
      });
    });
  });

  /* ---------- Colour swatches ---------- */
  $$("[data-swatches] .swatch").forEach((sw) => {
    sw.addEventListener("click", () => {
      $$("[data-swatches] .swatch").forEach((s) => s.classList.remove("is-active"));
      sw.classList.add("is-active");
      const label = $("[data-swatch-label]");
      if (label && sw.dataset.colour) label.textContent = sw.dataset.colour;
    });
  });

  /* ---------- Read more (PDP description) ---------- */
  $$("[data-readmore]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const target = $("#" + btn.getAttribute("data-readmore"));
      if (!target) return;
      target.hidden = !target.hidden;
      btn.textContent = target.hidden ? "Read more" : "Read less";
    });
  });
})();

/* ============================================================
   ADDED: localization dropdowns + variant image switching
   ============================================================ */
(function () {
  "use strict";
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* ---------- Localization (EN + country) dropdowns ---------- */
  $$("[data-locale-toggle]").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      const wrap = btn.closest("[data-locale]");
      const open = wrap.classList.contains("is-open");
      $$("[data-locale].is-open").forEach((w) => w.classList.remove("is-open"));
      if (!open) wrap.classList.add("is-open");
    });
  });
  document.addEventListener("click", () =>
    $$("[data-locale].is-open").forEach((w) => w.classList.remove("is-open"))
  );

  /* ---------- Collection card: swatch swaps card image ---------- */
  $$("[data-card]").forEach((card) => {
    const baseImg = $("[data-card-img]", card);
    const hoverImg = $(".card__media img.is-hover", card);
    const colourLabel = $("[data-card-colour]", card);
    $$("[data-card-swatches] .card__swatch", card).forEach((sw) => {
      sw.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const src = sw.getAttribute("data-img");
        // Update BOTH layers: the hover image sits on top while the cursor is
        // over the card, so the base alone would be hidden during the click.
        if (src) {
          if (baseImg) baseImg.src = src;
          if (hoverImg) hoverImg.src = src;
        }
        if (colourLabel && sw.dataset.name) colourLabel.textContent = sw.dataset.name;
        $$("[data-card-swatches] .card__swatch", card).forEach((s) => s.classList.remove("is-active"));
        sw.classList.add("is-active");
      });
    });
  });

  /* ---------- Header search panel ---------- */
  const searchPanel = $("[data-search-panel]");
  const searchToggle = $("[data-search-toggle]");
  const searchInput = $("[data-search-input]");
  function openSearch() {
    if (!searchPanel) return;
    searchPanel.hidden = false;
    if (searchToggle) searchToggle.setAttribute("aria-expanded", "true");
    requestAnimationFrame(() => searchInput && searchInput.focus());
  }
  function closeSearch() {
    if (!searchPanel) return;
    searchPanel.hidden = true;
    if (searchToggle) searchToggle.setAttribute("aria-expanded", "false");
  }
  if (searchToggle) {
    searchToggle.addEventListener("click", (e) => {
      e.stopPropagation();
      searchPanel.hidden ? openSearch() : closeSearch();
    });
  }
  $$("[data-search-close]").forEach((b) => b.addEventListener("click", closeSearch));
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeSearch(); });
  if (searchPanel) searchPanel.addEventListener("click", (e) => e.stopPropagation());
  document.addEventListener("click", () => { if (searchPanel && !searchPanel.hidden) closeSearch(); });

  /* ---------- Voice search ---------- */
  (function () {
    const micBtn = $("[data-voice-search]");
    if (!micBtn) return;
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SR) { micBtn.hidden = true; return; } // hide on unsupported browsers
    const form = micBtn.closest("form");
    let rec = null, listening = false;
    micBtn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (listening && rec) { rec.stop(); return; }
      rec = new SR();
      rec.lang = document.documentElement.lang || "en-GB";
      rec.interimResults = false;
      rec.maxAlternatives = 1;
      rec.onstart = () => { listening = true; micBtn.classList.add("is-listening"); };
      rec.onend = () => { listening = false; micBtn.classList.remove("is-listening"); };
      rec.onerror = () => { listening = false; micBtn.classList.remove("is-listening"); };
      rec.onresult = (ev) => {
        const text = (ev.results[0][0].transcript || "").trim();
        if (searchInput) { searchInput.value = text; searchInput.focus(); }
        if (text && form) form.submit();
      };
      try { rec.start(); } catch (err) { /* already started */ }
    });
  })();

  /* ---------- Photo / camera search ---------- */
  (function () {
    const camBtn = $("[data-photo-search]");
    const fileInput = $("[data-photo-input]");
    if (!camBtn || !fileInput) return;
    const endpoint = camBtn.getAttribute("data-endpoint") || "";
    camBtn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      fileInput.click();
    });
    fileInput.addEventListener("change", async () => {
      const file = fileInput.files && fileInput.files[0];
      if (!file) return;
      if (!endpoint) {
        alert("Photo search isn’t set up yet.");
        fileInput.value = "";
        return;
      }
      camBtn.classList.add("is-busy");
      try {
        const fd = new FormData();
        fd.append("image", file);
        const res = await fetch(endpoint, { method: "POST", body: fd });
        const data = await res.json().catch(() => ({}));
        if (data && data.url) { window.location.href = data.url; return; }
        if (data && data.q) { window.location.href = "/search?q=" + encodeURIComponent(data.q); return; }
        alert("No matching products found.");
      } catch (err) {
        alert("Photo search failed. Please try again.");
      } finally {
        camBtn.classList.remove("is-busy");
        fileInput.value = "";
      }
    });
  })();

  /* ---------- PDP: full variant picker (colour swatches + option pills) ---------- */
  const picker = $("[data-variant-picker]");
  if (picker) {
    const jsonEl = $("[data-variant-json]", picker);
    let variants = [];
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) {}

    const mainImg = $("[data-pdp-main]");
    const priceEl = $("[data-pdp-price]");
    const variantInput = $("[data-variant-input]");
    const addBtn = $("[data-add-btn]", picker);
    const addLabel = $("[data-add-label]", picker);

    // selected values keyed by option position (1-based)
    let selected = {};
    try { (JSON.parse(picker.getAttribute("data-current-options")) || []).forEach((v, i) => { selected[i + 1] = v; }); } catch (e) {}

    function swapImage(src) {
      if (!src || !mainImg) return;
      mainImg.style.opacity = "0";
      const pre = new Image();
      pre.onload = () => { mainImg.src = src; mainImg.style.opacity = "1"; };
      pre.src = src;
    }

    function findVariant() {
      return variants.find((v) =>
        Object.keys(selected).every((pos) => v.options[pos - 1] === selected[pos])
      );
    }

    function update() {
      const v = findVariant();
      if (!v) {
        if (addBtn) { addBtn.disabled = true; }
        if (addLabel) addLabel.textContent = "Unavailable";
        return;
      }
      if (variantInput) variantInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (v.image) swapImage(v.image);
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? "Add to cart" : "Sold out";
      // sync URL
      if (window.history && history.replaceState) {
        try { history.replaceState({}, "", "?variant=" + v.id); } catch (e) {}
      }
    }

    // wire every option control (swatch or pill)
    $$("[data-option-position]", picker).forEach((ctrl) => {
      ctrl.addEventListener("click", () => {
        const pos = ctrl.getAttribute("data-option-position");
        const val = ctrl.getAttribute("data-value");
        selected[pos] = val;

        // active state within this option group
        const group = ctrl.closest("[data-option-group]");
        $$("[data-option-position]", group).forEach((c) => c.classList.remove("is-active"));
        ctrl.classList.add("is-active");

        // update the group's selected label
        const lbl = $('[data-selected-label="' + pos + '"]');
        if (lbl) lbl.textContent = val;

        // immediate image feedback from a colour swatch
        const img = ctrl.getAttribute("data-img");
        if (img) swapImage(img);

        update();
      });
    });
  }
})();

/* ============================================================
   ADDED: AJAX cart (add / change) — no navigation to /cart
   ============================================================ */
(function () {
  "use strict";
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  let qtyBusy = false;
  async function changeLine(key, qty) {
    if (qtyBusy) return;
    qtyBusy = true;
    try {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: qty }),
      });
      if (window.__refreshCartDrawer) { await window.__refreshCartDrawer(false); }
    } finally { qtyBusy = false; }
  }

  /* Delegated quantity steppers — work on the server-rendered drawer AND on
     any drawer markup swapped in later via the Section Rendering API. */
  document.addEventListener("click", (e) => {
    const minus = e.target.closest("[data-qty-minus]");
    const plus = e.target.closest("[data-qty-plus]");
    if (!minus && !plus) return;
    const wrap = (minus || plus).closest("[data-qty]");
    if (!wrap) return;
    const key = wrap.getAttribute("data-line");
    const out = wrap.querySelector("[data-qty-val]");
    let v = parseInt(out.textContent, 10) || 1;
    v = plus ? v + 1 : Math.max(0, v - 1);
    out.textContent = v; // optimistic; server value confirmed on refresh
    if (key) changeLine(key, v);
  });
})();

/* ============================================================
   ADDED: AJAX add-to-cart (no navigation) + drawer refresh
   ============================================================ */
(function () {
  "use strict";
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  function setCartCounts(count) {
    $$("[data-cart-count]").forEach((el) => { el.textContent = count; });
  }

  // Pull a fresh cart drawer via the Section Rendering API and swap it in.
  async function refreshDrawer(openAfter) {
    const wasOpen = !!document.querySelector("[data-drawer].is-open");
    try {
      const res = await fetch("/?sections=cart-drawer", { headers: { "Accept": "application/json" } });
      const data = await res.json();
      const html = data["cart-drawer"];
      const wrap = document.getElementById("shopify-section-cart-drawer");
      if (html && wrap) {
        const tmp = document.createElement("div");
        tmp.innerHTML = html;
        const fresh = tmp.querySelector("#shopify-section-cart-drawer") || tmp.firstElementChild;
        if (fresh) wrap.replaceWith(fresh);
      }
    } catch (e) { /* drawer markup stays as-is */ }

    // refresh count from cart.js
    try {
      const c = await (await fetch("/cart.js", { headers: { "Accept": "application/json" } })).json();
      setCartCounts(c.item_count);
    } catch (e) {}

    if ((openAfter || wasOpen) && window.__openCartDrawer) window.__openCartDrawer();
  }
  window.__refreshCartDrawer = refreshDrawer;

  // Intercept add-to-cart so it never navigates to /cart.
  document.addEventListener("submit", async (e) => {
    const form = e.target.closest('form[action*="/cart/add"], #addForm');
    if (!form) return;
    e.preventDefault();

    const btn = form.querySelector('[type="submit"]');
    const label = btn ? btn.querySelector("[data-add-label]") || btn : null;
    const prev = label ? label.textContent : "";
    if (btn) btn.disabled = true;
    if (label) label.textContent = "Adding…";

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: new FormData(form),
      });
      if (!res.ok) throw new Error("add failed");
      await refreshDrawer(true);
      if (label) label.textContent = "Added";
      setTimeout(() => { if (label) label.textContent = prev || "Add to cart"; }, 1200);
    } catch (err) {
      if (label) label.textContent = prev || "Add to cart";
    } finally {
      if (btn) btn.disabled = false;
    }
  });

  /* ---------- Sticky header (condense on scroll) ---------- */
  (function () {
    const header = $("[data-header]");
    if (!header || header.getAttribute("data-sticky") === "false") return;
    const wrap = header.parentElement; // the sticky .shopify-section wrapper
    let ticking = false;
    function update() {
      const pinned = wrap ? wrap.getBoundingClientRect().top <= 0 : window.scrollY > 10;
      header.classList.toggle("is-stuck", pinned);
      ticking = false;
    }
    window.addEventListener("scroll", () => {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  })();
})();
